import React, { useState, Fragment } from "react"
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Chip,
} from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import CloseIcon from "@mui/icons-material/Close"
import PropTypes from "prop-types"
import i18n from "i18n"

const TaxField = ({
  options = [],
  label = "",
  selectedTaxes = [],
  size = "medium",
  onChange = () => {},
  readOnly = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleAddTax = tax => {
    const alreadyHasType = selectedTaxes.some(t => t.type === tax.type)
    if (!selectedTaxes.some(t => t.SK === tax.SK) && !alreadyHasType) {
      const newTaxes = [...selectedTaxes, tax]
      onChange(newTaxes)
    }
    handleClose()
  }
  const handleRemoveTax = tax => {
    const newTaxes = selectedTaxes.filter(t => t.SK !== tax.SK)
    onChange(newTaxes)
  }
  return (
    <Box
      sx={{
        border: "1px solid #c0c0c0",
        borderRadius: 1,
        p: size === "small" ? 1 : 2,
        height: size === "small" ? 40 : 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        ...(readOnly ? { background: "#f5f5f5", pointerEvents: "none" } : {}),
      }}
    >
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          gap: 1,
          overflowX: "auto",
          alignItems: "center",
        }}
      >
        {selectedTaxes.length > 0 ? (
          selectedTaxes.map((tax, idx) => (
            <Box
              key={tax.SK || idx}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              <Chip
                label={tax.name}
                size="small"
                sx={{
                  fontSize: 12,
                  borderRadius: "2px",
                  backgroundColor: tax.type === "tax" ? "#e3f2fd" : "#e8f5e9",
                  color: tax.type === "tax" ? "#0d47a1" : "#1b5e20",
                }}
              />
              {!readOnly && (
                <IconButton
                  size="small"
                  onClick={() => handleRemoveTax(tax)}
                  sx={{ padding: 0, width: 14, height: 14 }}
                >
                  <CloseIcon sx={{ fontSize: 12 }} />
                </IconButton>
              )}
            </Box>
          ))
        ) : (
          <Typography
            variant="body2"
            sx={{ color: "#616161", fontSize: size === "small" ? 15 : 16 }}
          >
            {label}
          </Typography>
        )}
      </Box>
      {!readOnly && (
        <IconButton
          size="small"
          onClick={handleClick}
          sx={{
            backgroundColor: "#eeeeee",
            borderRadius: "4px",
            padding: "3px",
            marginLeft: 1,
            flexShrink: 0,
          }}
        >
          <AddIcon sx={{ fontSize: 16 }} />
        </IconButton>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: 320,
            overflowY: "auto",
          },
        }}
      >
        {options.length > 0 ? (
          (() => {
            const groups = ["tax", "retention", "surcharge"]

            return options.map((tax, idx, arr) => {
              const showDivider = idx === 0 || tax.type !== arr[idx - 1].type
              return (
                <Fragment key={tax.SK}>
                  {showDivider && idx !== 0 && (
                    <Box sx={{ borderTop: "1px solid #ccc", my: 0.5 }} />
                  )}
                  <MenuItem onClick={() => handleAddTax(tax)}>
                    {tax.name}
                  </MenuItem>
                </Fragment>
              )
            })
          })()
        ) : (
          <Box>
            <Typography
              variant="body2"
              sx={{ width: 200, px: 1, fontSize: 12 }}
            >
              {i18n.t("taxes.noTaxesAvailable")}
            </Typography>
          </Box>
        )}
      </Menu>
    </Box>
  )
}

TaxField.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  selectedTaxes: PropTypes.array,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium"]),
  readOnly: PropTypes.bool,
}

export default TaxField
